import { ExportFilter, PrepareForExport } from '@/lib/table/table'
import { DeleteWithList } from '@/lib/database/database'
import { className } from '@/components/common/styles'
import { performExport } from '@/components/common/table/performExport'

export type Action = 'delete' | 'download' | 'dummy'

interface SetAction {
  setAction(action: Action): void
}

type SelectedRowsIds = {
  [key: number]: boolean
}

export type HasId = { id: number }

interface BulkActionButtonProps<T extends HasId> {
  data?: T[]
  selectedRowIds: SelectedRowsIds
  action: Action
  deleteWithList: DeleteWithList<T>
  prepareForExport: PrepareForExport<T>
}

type DeleteButtonProps<T extends HasId> = {
  data: T[]
  selectedRowIds: SelectedRowsIds
  deleteWithList: DeleteWithList<T>
}

type DownloadButtonProps<T extends HasId> = {
  data: T[]
  selectedRowIds: SelectedRowsIds
  prepareForExport: PrepareForExport<T>
}

// @@TODO: Determine most efficient way to extract data (might be different for DOWNLOAD and DELETE)
const ExportButton = <T extends HasId>({
  data,
  selectedRowIds,
  prepareForExport,
}: DownloadButtonProps<T>) => {
  const filterSelection = (): T[] => {
    // selectedRowIds is in a peculiar format, must be transformed to a usable format
    const valArray = Object.keys(selectedRowIds).map(Number)
    console.log('valArray=', valArray)
    // NOTE: Intentional _row
    const selection = data.filter((_row, index) => {
      return valArray.includes(index)
    })
    console.log('selection=', selection)
    return selection
  }

  return (
    <button
      type="button"
      className={className}
      onClick={() => {
        console.log(
          'You clicked the link - count to be exported=',
          Object.keys(selectedRowIds).length,
        )
        if (Object.keys(selectedRowIds).length === 0) {
          console.log('No rows selected! Cannot perform export!')
        } else {
          const result = filterSelection()
          performExport(prepareForExport(result))
        }
      }}
    >
      Apply
    </button>
  )
}

const DeleteButton = <T extends HasId>({
  data,
  selectedRowIds,
  deleteWithList,
}: DeleteButtonProps<T>) => {
  return (
    <button
      type="button"
      className={className}
      onClick={(e) => {
        if (Object.keys(selectedRowIds).length === 0) {
          console.log('No row(s) selected! Cannot perform delete!')
          e.stopPropagation()
        }
        const deleteIds: number[] = []
        // Extract Number 'id' from Array of Objects (indexed by String)
        Object.keys(selectedRowIds).forEach((key) => {
          const id = data[Number.parseInt(key)]['id']
          deleteIds.push(id)
        })
        console.log('deleteIds=', deleteIds)
        const result = deleteWithList(deleteIds)
        console.log('result=', result)
        // @@TODO: delete should trigger an automatic rerender
      }}
    >
      Apply
    </button>
  )
}

export const BulkActionButton = <T extends HasId>({
  data,
  selectedRowIds,
  action,
  deleteWithList,
  prepareForExport,
}: BulkActionButtonProps<T>) => {
  const result = <div />
  if (data) {
    switch (action) {
      case 'delete':
        return (
          <DeleteButton
            data={data}
            selectedRowIds={selectedRowIds}
            deleteWithList={deleteWithList}
          />
        )
      case 'download':
        return (
          <ExportButton
            data={data}
            selectedRowIds={selectedRowIds}
            prepareForExport={prepareForExport}
          />
        )
      case 'dummy':
        break
      default:
        break
    }
  }
  return result
}

export function BulkActionSelect({ setAction }: Readonly<SetAction>) {
  return (
    <label className="flex gap-x-2 items-baseline">
      <span className="text-gray-500 dark:text-gray-400">{'Bulk action:'}</span>
      <select
        className="bg-white dark:bg-black text-black dark:text-white"
        name="bulkActionSelect"
        id="bulkActionSelect"
        defaultValue="select"
        onChange={(e) => {
          console.log('selected', e.target.value)
          setAction(e.target.value as Action)
        }}
      >
        <option value="select" disabled>
          Bulk action...
        </option>
        <option value="delete">Delete</option>
        <option value="download">Download</option>
      </select>
    </label>
  )
}
